/** The worker's own record: Today, jobs in person, getting paid, the record, Settings. */
export const worker = {
    "stat.waiting": "Waiting",
    "getpaid.cash": "Paid in cash",
    "getpaid.scan": "Scan to pay",
    "getpaid.qr_alt": "UPI QR for {price} to {vpa}",
    "getpaid.to": "to {name} · {vpa}",
    "getpaid.scan_about": "The customer scans with any UPI app. The money goes straight to your bank.",
    "payrow.ref": "ref {utr}",
    "method.upi": "UPI",
    "method.cash": "Cash",
    "settings.soft": "Kept on this device.",
    "settings.paid_to": "Get paid to",
    "settings.vpa": "Your UPI ID",
    "settings.name": "Your name, as customers see it",
    "settings.saved": "Saved on this device",
    "settings.change": "Change",
    "settings.save": "Save",
    "settings.vpa_about": "Shown only inside your payment QR, or sent locked to a customer you are working with. Never stored on a server.",
    "settings.look": "Look",
    "look.auto": "Auto",
    "look.light": "Light",
    "look.dark": "Dark",
    "pack.title": "Understanding pack",
    "pack.about": "A small model ({mb} MB, downloaded once) that reads what you mean in English, Hindi and Kannada, on this device. Nothing you type leaves the phone, and everything still works without it.",
    "pack.get": "Download ({mb} MB)",
    "pack.downloading": "Downloading… {percent}%",
    "pack.ready": "Ready · runs on this device",
    "pack.failed": "The download did not finish. Check your connection and try again.",
    "pack.lite": "Off in lite mode.",
    "settings.err_vpa": "That does not look like a UPI ID (name@bank).",
    "settings.err_name": "Enter the name customers will see when they pay you.",
    "settings.err_name_long": "Keep the name to {max} characters.",
};
//# sourceMappingURL=worker.js.map